import React, { FC } from 'react'
import { dummyContainer, dummyContainerMobile, nextLinkHeader, nextPageLink, nextPageLinkMobile, overlay } from '../styles'
import { ArrowRight } from 'lucide-react'
import { NextPageProps } from '../types'
import { Link } from 'gatsby'
import settings from '@settings'
import { useMediaQuery } from 'usehooks-ts'
import { getImageUrl } from '@provider'

const NextPage: FC<NextPageProps> = ({nextPage}) => {
    const isTableOrMobile = useMediaQuery('(max-width: 768px)');
    console.log({nextPage});
    
    if (isTableOrMobile && nextPage) return (
        <div css={dummyContainerMobile} >
            <div css={overlay} />
            <img 
                css={{width: '100%', height: '100%', zIndex: 1, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', objectFit: 'cover'}}
                src={getImageUrl({filePath: nextPage.image, width: 2024})}
                alt={nextPage.header}
                
            />
            <Link
                css={nextPageLinkMobile}
                to={`/projekte/${nextPage.slug}`}>
                    <div  css={[nextPageLink]}>
                            Nächstes Projekt
                </div>
                        <div>
                            <ArrowRight size={24} strokeWidth={3}  />
                        </div>
            </Link>
        </div>
    )
    
    if (nextPage) {
        return (
            <div css={dummyContainer} >
                <Link
                css={{color: `${settings.colors.white} !important`, textAlign: 'center'}}
                to={`/projekte/${nextPage.slug}`}>
                <div 
                    css={{position: 'relative', cursor: 'pointer'}}
                >
                    <div  css={[nextPageLink]}>
                           
                                Nächste Seite
                            <span>
                                <ArrowRight size={11} />
                            </span>
                    </div>
                </div>
                <h4 css={nextLinkHeader}>
                    {nextPage.header}
                </h4>
                </Link>
            </div>
        )
    }

    return null;
}

export default NextPage